module.exports = __webpack_public_path__ + "static/media/icon_liw.6697a70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_liw.png
// module id = 141
// module chunks = 0